document.addEventListener("DOMContentLoaded", () => {

    const cursor = document.querySelector(".material-cursor");

    if (!cursor) return;

    const text = cursor.querySelector(".material-cursor__text");
    const cards = document.querySelectorAll(".material-card");

    let mouseX = 0;
    let mouseY = 0;

    let currentX = 0;
    let currentY = 0;

    let hovering = false;
    let raf = null;

    function animate() {

        currentX += (mouseX - currentX) * 0.18;
        currentY += (mouseY - currentY) * 0.18;

        cursor.style.transform =
            `translate3d(${currentX}px, ${currentY}px,0) translate(-50%,-50%) scale(1)`;

        if (hovering) {
            raf = requestAnimationFrame(animate);
        } else {
            raf = null;
        }

    }

    window.addEventListener("pointermove", e => {

        mouseX = e.clientX;
        mouseY = e.clientY;

    }, { passive:true });


    cards.forEach(card => {

        card.addEventListener("pointerenter", () => {

            hovering = true;

            text.textContent = card.dataset.hover || "";

            cursor.style.opacity = "1";

            if (!raf) {
                animate();
            }

        });

        card.addEventListener("pointerleave", () => {

            hovering = false;

            cursor.style.opacity = "0";

            cursor.style.transform =
                `translate3d(${currentX}px,${currentY}px,0) translate(-50%,-50%) scale(.3)`;

        });

    });

    window.addEventListener("scroll", () => {

        hovering = false;

        cursor.style.opacity = "0";

    }, { passive:true });

});